import io from 'socket.io-client';

let socket;

export function iniciarSocket(idAtendimento) {
    if (socket) {
      socket.disconnect();
      socket = null;
    }
  
    socket = io(process.env.VUE_APP_SOCKET_API, {
      autoConnect: false,
      query: { idAtendimento }
    });
  
    return socket;
}

export function getSocket() {
  return socket;
}
